(function () {
  'use strict';

  /* @ngdoc object
   * @name cabinFlightIssues
   * @description
   *
   */
  angular
    .module('cabinFlightIssues', [
      'ui.router'
    ]);
}());
